<script>
import {alphaNum, maxLength, email, required, url} from "vuelidate/lib/validators";
import {
  validatePresence,
  validateEmail,
  validatePhoneNumber,
  validateURL,
  validatePassword,
  validateConfirmPassword,
  validateZip,

} from "@/utils";
import usStates from "@/data/usStates.json";
import countries from "@/data/countries.json";
import {updateAccountSettings} from "@/api/accounts";
import swal from "sweetalert";


export default {
  name: "account-settings",
  validations: {
    form: {
      first_name: {
        maxLength: maxLength(255)
      },
      last_name: {
        maxLength: maxLength(255)
      },
      company_name: {
        maxLength: maxLength(255)
      },
      company_website_url: {
        url
      },
    },

  },
  data() {
    return {
      editMode: false,
      form: {},
      original: {},
      usStates: [],
      countries: [],
      valid: {
        first_name: true,
        last_name: true,
        email: true,
        company_name: true,
        company_website_url: true,
        company_logo_file: true,
        street: true,
        city: true,
        state: true,
        zip: true,
        country: true
      },
      loading: false,
      btnSubmitTxt: "Save"
    };
  },
  async mounted() {
    await this.getAccountSettings();
  },
  watch: {

    "form.email"(value) {
      this.form.email = value;
      this.valid.email = validateEmail(value);
    },
    "form.phone_number"(value) {
      this.form.phone_number = value;
      this.valid.phone_number = validatePhoneNumber(value);

    },
    "form.password"(value) {
      this.form.password = value;
      this.valid.password = validatePassword(value);
      if (value) {
        this.valid.confirm_password = validateConfirmPassword(
            this.form.password,
            this.form.confirm_password
        );
      }
    },
    "form.confirm_password"(value) {
      this.form.confirm_password = value;
      this.valid.confirm_password = validateConfirmPassword(
          this.form.password,
          value
      );
    },
    "form.company_logo_file"(file) {
      if (file === null) {
        this.valid.company_logo_file = true;
        return;
      }
      if (file.size <= 2000048) {
        this.valid.company_logo_file = true;
        const reader = new FileReader();
        let formRef = this.form;
        reader.addEventListener("load", function () {
          // Update the preview and set Base64 form field
          formRef.company_logo = reader.result;
        });
        reader.readAsDataURL(file);
      } else {
        this.valid.company_logo_file = false;
        console.log(this.valid);
      }
    },
    "form.street"(value) {
      this.form.street = value;
      this.valid.street = validatePresence(value);
    },
    "form.city"(value) {
      this.form.city = value;
      this.valid.city = validatePresence(value);
    },
    "form.state"(value) {
      this.form.state = value;
      this.valid.state = validatePresence(value);
    },
    "form.zip"(value) {
      this.form.zip = value;
      this.valid.zip = validateZip(value);
    },
    "form.country"(value) {
      this.form.country = value;
      this.valid.country = validatePresence(value);
    }
  },
  methods: {
    onSubmit() {
    },
    removeLogo() {
      this.$set(this.form, "company_logo", null);

    },
    async getAccountSettings() {
      // Get field information
      await this.$store.dispatch("getAccountSettings");
      let accountSettings = this.$store.getters["getAccountSettings"];
      // Pre-fill form with field information.
      this.form = accountSettings;
      // Add reactive password and confirm_password fields.
      this.$set(this.form, "password", "");
      this.$set(this.form, "confirm_password", "");
      this.$set(this.form, "company_logo_file", null);
      // Make a static copy to revert changes on cancel.
      this.original = Object.assign({}, this.form);
    },
    checkAll() {
      for (const field in this.valid) {
        if (this.valid[field] === false) {
          this.submitButton.setAttribute("disabled", "true");
          this.submitButton.classList.add("pointer-events-none");
          return false;
        }
      }
      this.submitButton.removeAttribute("disabled");
      this.submitButton.classList.remove("pointer-events-none");
      return true;
    },
    submitAccountSettings() {
      if (!this.checkAll()) {
        console.log("Failed checks");
        return;
      }
      const payload = JSON.parse(
          JSON.stringify({
            name:
                (this.form.first_name ? this.form.first_name.trim() : "") +
                " " +
                (this.form.last_name ? this.form.last_name.trim() : ""),
            first_name: this.form.first_name ? this.form.first_name.trim() : "",
            last_name: this.form.last_name ? this.form.last_name.trim() : "",
            email: this.form.email ? this.form.email.trim() : "",
            phone_number: this.form.phone_number
                ? this.form.phone_number.trim()
                : "",
            company_name: this.form.company_name
                ? this.form.company_name.trim()
                : "",
            company_website_url: this.form.company_website_url
                ? this.form.company_website_url.trim()
                : "https://YourUrl.com",
            company_logo: this.form.company_logo,
            street: this.form.street ? this.form.street.trim() : "",
            city: this.form.city ? this.form.city.trim() : "",
            state: this.form.state ? this.form.state.trim() : "",
            zip: this.form.zip ? this.form.zip.trim() : "",
            country: this.form.country ? this.form.country.trim() : "United States",
            password: this.form.password,
            confirm_password: this.form.confirm_password
          })
      );
      this.loading = true;
      this.btnSubmitTxt = "Updating...";
      updateAccountSettings(payload).then(() => {
        this.getAccountSettings().then(() => {
          swal("Account", "Information successfully updated");
          // Turns off edit mode and resets form to show changes.
          this.editMode = false;
          this.loading = false;
          this.btnSubmitTxt = "Save";
          this.form = Object.assign(this.form, this.original);
        });
      });
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
      // On Edit and Cancel, reset form.
      this.form = Object.assign(this.form, this.original);
    }
  },
  computed: {
    countriesOptions() {
      return [
        {value: "United States", text: "United States"},
        ...countries.map(list => {
          return {
            value: list.name,
            text: list.name
          };
        })
      ];
    },
    statesOptions() {
      return [
        {value: null, text: "Please select"},
        ...usStates.map(list => {
          return {
            value: list.name,
            text: list.name
          };
        })
      ];
    },
    buttonText() {
      if (this.editMode) {
        return "Cancel";
      }
      return "Edit";
    },
    submitButton() {
      return document.querySelector(".submitButton");
    }
  }
};
</script>

<template>
  <v-card>
    <form
        class="account-settings-form"
        method="POST"
        v-on:change="checkAll"
        v-on:submit.prevent="onSubmit"
    >
      <v-card-title>
        Account Settings
        <div class="btn-group">
          <b-button
              class="submitButton"
              type="submit"
              v-on:click="submitAccountSettings"
              v-if="editMode"
              :disabled="loading"
          >
            {{ btnSubmitTxt }}
          </b-button
          >
          <b-button v-on:click="toggleEditMode" v-b-modal.modal-multi-4>
            {{ buttonText }}
          </b-button
          >
        </div>
      </v-card-title>
      <v-card-text>
        The following information will help us automatically build your email
        footers to comply with the CAN-SPAM act and international anti-spam
        laws.
      </v-card-text>
      <v-container fluid>
        <div class="row">
          <div class="col-lg-4">
            <b-form-group label="First Name" :class="{ 'form-group--error': $v.form.first_name.$error }">
              <b-form-input
                  v-model.trim="$v.form.first_name.$model"
                  name="first_name"
                  v-bind:value="this.form.first_name"
                  v-bind:disabled="!editMode"
              ></b-form-input>
              <p class="error">
                <span class="d-block p-1" v-if="!$v.form.first_name.maxLength">Field can only take maximum of
            {{ $v.form.first_name.$params.maxLength }} letters</span>
              </p>
            </b-form-group>

            <b-form-group label="Last Name" :class="{ 'form-group--error': $v.form.last_name.$error }">
              <b-form-input
                  name="last_name"
                  v-model.trim="$v.form.last_name.$model"
                  v-bind:value="this.form.last_name"
                  v-bind:disabled="!editMode"
              ></b-form-input>
              <p class="error">

                <span class="d-block p-1" v-if="!$v.form.last_name.maxLength">Field can only take maximum of
            {{ $v.form.last_name.$params.maxLength }} letters</span>
              </p>
            </b-form-group>
            <div>
              <label>Email</label>
              <b-form-input
                  v-bind:class="{ 'is-invalid': !valid.email }"
                  v-model="form.email"
                  name="email"
                  v-bind:value="this.form.email"
                  v-bind:disabled="!editMode"
              ></b-form-input>
              <div class="invalid-feedback">
                Please enter a valid email.
              </div>
            </div>
            <div>
              <label>Phone Number</label>
              <b-form-input
                  v-bind:class="{ 'is-invalid': !valid.phone_number }"
                  v-model="form.phone_number"
                  name="phone_number"
                  v-bind:value="this.form.phone_number"
                  v-bind:disabled="!editMode"
                  type="tel"
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"

              ></b-form-input>
              <div class="invalid-feedback">
                Please enter a valid phone number.
              </div>
            </div>
            <div>
              <label>Change Password</label>
              <b-form-input
                  v-bind:class="{ 'is-invalid': !valid.password }"
                  v-model="form.password"
                  name="password"
                  type="password"
                  placeholder="Leave blank to skip"
                  v-bind:disabled="!editMode"
              ></b-form-input>
              <div class="invalid-feedback">
                Password must contain at least 8 characters.
              </div>
            </div>
            <div>
              <label>Confirm New Password</label>
              <b-form-input
                  v-bind:class="{ 'is-invalid': !valid.confirm_password }"
                  v-model="form.confirm_password"
                  name="confirm_password"
                  type="password"
                  placeholder="Leave blank to skip"
                  v-bind:disabled="!editMode"
              ></b-form-input>
              <div class="invalid-feedback">Passwords must match.</div>
            </div>
          </div>

          <div class="col-lg-4">
            <b-form-group label="Company Name" :class="{ 'form-group--error': $v.form.company_name.$error }">
              <b-form-input
                  v-model.trim="$v.form.company_name.$model"
                  v-bind:value="this.form.company_name"
                  v-bind:disabled="!editMode"
              ></b-form-input>
              <p class="error">
                <span class="d-block p-1" v-if="!$v.form.company_name.maxLength">Field can only take maximum of
            {{ $v.form.company_name.$params.maxLength }} letters</span>
              </p>
            </b-form-group>

            <div>
              <b-form-group label="Company Website"
                            :class="{ 'form-group--error': $v.form.company_website_url.$error }">
                <b-form-input
                    v-model.trim="$v.form.company_website_url.$model"
                    name="company_website_url"
                    v-bind:value="this.form.company_website_url"
                    v-bind:disabled="!editMode"
                ></b-form-input>
                <p class="error">
                  <span class="d-block p-1" v-if="!$v.form.company_website_url.url">Please enter a valid URL.</span>
                </p>
              </b-form-group>
            </div>
            <div>
              <label>
                Company Logo
                <small style="color: rgb(161, 161, 161)">(max 2 MB)</small>
              </label>
              <b-form-file
                  v-bind:class="{ 'is-invalid': !valid.company_logo_file }"
                  name="form.company_logo_file"
                  accept="image/*"
                  v-model="form.company_logo_file"
                  placeholder="Choose a file or drop it here"
                  drop-placeholder="Drop file here"
                  v-bind:disabled="!editMode"
                  style="margin-bottom: 16px"
              ></b-form-file>
              <div class="invalid-feedback">
                Please choose an image file under 2 MB.
              </div>
              <div class="mt-3">
                <b-button v-bind:disabled="!editMode" @click="removeLogo()" size="sm">Remove logo</b-button>
                <img class="logo-preview" v-bind:src="form.company_logo"/>
              </div>

            </div>
          </div>
          <div class="col-lg-4">
            <div>
              <label>Street</label>
              <b-form-input
                  v-bind:class="{ 'is-invalid': !valid.street }"
                  v-model="form.street"
                  name="street"
                  id="street"
                  v-bind:value="this.form.street"
                  v-bind:disabled="!editMode"
              ></b-form-input>
              <div class="invalid-feedback">Street cannot be blank.</div>
            </div>
            <div>
              <label>City</label>
              <b-form-input
                  v-bind:class="{ 'is-invalid': !valid.city }"
                  v-model="form.city"
                  name="city"
                  v-bind:value="this.form.city"
                  v-bind:disabled="!editMode"
              ></b-form-input>
              <div class="invalid-feedback">City cannot be blank.</div>
            </div>
            <div>
              <label>State</label>
              <b-form-select
                  v-bind:class="{ 'is-invalid': !valid.state }"
                  v-model="form.state"
                  name="state"
                  id="state"
                  v-bind:value="this.form.state"
                  v-bind:disabled="!editMode"
                  :options="statesOptions"
              ></b-form-select>
              <div class="invalid-feedback">State cannot be blank.</div>
            </div>
            <div>
              <label>Zip</label>
              <b-form-input
                  v-bind:class="{ 'is-invalid': !valid.zip }"
                  v-model="form.zip"
                  id="zip"
                  name="zip"
                  v-bind:value="this.form.zip"
                  v-bind:disabled="!editMode"
              ></b-form-input>
              <div class="invalid-feedback">Please enter a valid zip.</div>

            </div>
            <div>
              <label>Country</label>
              <b-form-select
                  v-bind:class="{ 'is-invalid': !valid.country }"
                  v-model="form.country"
                  id="country"
                  name="country"
                  v-bind:value="this.form.country"
                  v-bind:disabled="!editMode"
                  :options="countriesOptions"
                  disabled
              ></b-form-select>
              <div class="invalid-feedback">Country cannot be blank.</div>
            </div>
          </div>
        </div>
      </v-container>
    </form>
  </v-card>
</template>

<style scoped>
img.logo-preview {
  max-width: 100%;
}

.pointer-events-none {
  pointer-events: none !important;
}

.invalid-feedback {
  transform: translateY(-12px);
}

.btn-group {
  position: absolute;
  right: 16px;
  top: 16px;
}

.btn-group > * {
  margin-left: 16px !important;
  border-radius: 0.42rem !important;
}

input {
  margin-bottom: 16px;
}

span {
  background-color: white;
}

.error {
  color: #F64E60;
  /*margin-top: 2px;*/

}
</style>